import { useSelector } from 'src/hooks/useSelector';
import { ArticleTopics } from 'src/models/articlePage/types';

const useIsInsider: () => boolean = () => {
    const topics = useSelector((state) => state.articlePage.topics);
    return topics?.some((topic) => topic.code === ArticleTopics.Insider) || false;
};

export { useIsInsider };
